module.exports = __webpack_public_path__ + "img/default-taxi.13749e4c.svg";